exports.FLACDemuxer = require('./src/demuxer');
exports.FLACDecoder = require('./src/decoder');
require('./src/ogg');



/** WEBPACK FOOTER **
 ** ./src/modules/flac.js/index.js
 **/